<template>
  <div id="app">
      <router-view />
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name:'App',
  components:{
  },
  created() {
  },
  methods: {
  }

}
</script>

<style >
  *{
    padding: 0;
    margin: 0;
    list-style-type:none;
  }
</style>

